'use client';

import { CheckoutCard, Text } from '@instamenu/ui-system-next';
import { TableSelect } from '../table-select/table-select';
import { palette } from '@instamenu/ui-vanilla-extract';
import { Order } from '@instamenu/context-checkout';
import { observer } from 'mobx-react-lite';
import { TableMappingKind } from '@instamenu/data-access';

export const TableSection = observer(
  ({
    order,
    kind,
    hasWarning = false,
  }: {
    order: Order;
    kind?: TableMappingKind;
    hasWarning?: boolean;
  }) => (
    <CheckoutCard variant={hasWarning ? 'warning' : 'default'} data-id="table-section">
      <Text variant="caption1" css={{ color: palette.gray600, paddingBottom: 8 }}>
        {kind === TableMappingKind.PickupLocation
          ? 'Pickup location (required)'
          : order.isPickupLocation
            ? 'Pickup location'
            : 'Your table'}
      </Text>
      <TableSelect order={order} kind={kind} />
    </CheckoutCard>
  ),
);
